<div class="login-container">
    <div class="login-card">
        <app-header></app-header>

        <div *ngIf="!(isAuthenticated$ | async)">

            <div class="social-logins" *ngIf="showSocialLogin">
                <button (click)="signUpWithProvider('google')" class="social-btn" *ngIf="showGoogleLogin">
                    <img src="assets/google-icon.svg" alt="Google" />
                    <span class="social-login-text">Login with Google</span>
                </button>
                <button (click)="signUpWithProvider('apple')" class="social-btn" *ngIf="showAppleLogin">
                    <img src="assets/apple-icon.svg" alt="Apple" />
                    <span class="social-login-text">Apple</span>
                </button>
                <button (click)="signUpWithProvider('facebook')" class="social-btn" *ngIf="showFacebookLogin">
                    <img src="assets/facebook-icon.svg" alt="Facebook" />
                    <span class="social-login-text">Facebook</span>
                </button>
            </div>

            <div class="divider">
                <span>or sign up with email</span>
            </div>

            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" autocomplete="on">
                <div class="form-group">
                    <label for="email">Email</label>
                    <input id="email" type="email" formControlName="email" placeholder="Enter your email"
                        autocomplete="email" />
                    <div *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched"
                        class="error-message">
                        Please enter a valid email address
                    </div>
                </div>

                <div class="form-group" *ngIf="showNameCapture">
                    <label for="name">Full Name</label>
                    <input id="name" type="text" formControlName="name" placeholder="Enter your full name"
                        autocomplete="name" />
                    <div *ngIf="signupForm.get('name')?.invalid && signupForm.get('name')?.touched"
                        class="error-message">
                        Please enter your name
                    </div>
                </div>

                <div class="form-group password-group">
                    <label for="password">Password</label>
                    <div class="password-input">
                        <input id="new-password" [type]="showPassword ? 'text' : 'password'" formControlName="password"
                            placeholder="••••••••" autocomplete="new-password" />
                        <button type="button" class="toggle-password" tabindex="-1"
                            (click)="togglePasswordVisibility()">
                            <img [src]="
                  showPassword
                    ? 'assets/eye-off-icon.svg'
                    : 'assets/eye-icon.svg'
                " alt="Toggle password" />
                        </button>
                    </div>
                    <div *ngIf="signupForm.get('password')?.invalid && signupForm.get('password')?.touched"
                        class="error-message">
                        Password must be at least 8 characters
                    </div>
                </div>

                <div class="form-group password-group">
                    <label for="confirmPassword">Confirm Password</label>
                    <div class="password-input">
                        <input id="confirm-password" [type]="showConfirmPassword ? 'text' : 'password'"
                            formControlName="confirmPassword" placeholder="••••••••" autocomplete="new-password" />
                        <button type="button" class="toggle-password" tabindex="-1"
                            (click)="toggleConfirmPasswordVisibility()">
                            <img [src]="
                  showConfirmPassword
                    ? 'assets/eye-off-icon.svg'
                    : 'assets/eye-icon.svg'
                " alt="Toggle password" />
                        </button>
                    </div>
                    <div *ngIf="signupForm.errors?.['passwordMismatch'] && signupForm.get('confirmPassword')?.touched"
                        class="error-message">
                        Passwords don't match
                    </div>
                </div>

                <div class="form-group" *ngIf="showTermsAcceptance">
                    <div class="terms-checkbox">
                        <input type="checkbox" id="termsAccepted" formControlName="termsAccepted" />
                        <label for="termsAccepted">
                            I agree to the <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy
                                Policy</a>
                        </label>
                    </div>
                    <div *ngIf="signupForm.get('termsAccepted')?.invalid && signupForm.get('termsAccepted')?.touched"
                        class="error-message">
                        You must accept the terms to continue
                    </div>
                </div>

                <div class="form-footer">
                    <button type="submit" class="sign-in-btn" [disabled]="signupForm.invalid || isLoading">
                        {{ isLoading ? 'Creating account...' : 'Create account' }}
                    </button>
                </div>

                <div *ngIf="errorMessage" class="error-message">
                    {{ errorMessage }}
                </div>
            </form>



            <p class="create-account">
                Already have an account? <a href="/login">Sign in</a>
            </p>
        </div>
    </div>
</div>